import APIConfig from '../../apiconfig';

export const showAccountFriendlyName = () => APIConfig.showAccountFriendlyName;
